import {useQuery} from '@tanstack/react-query';

import {getCurrencies} from '../api';
import {QUERY__CURRENCIES} from '../queryKeys';

export const useGetCurrencies = () => {
  return useQuery({
    queryKey: [QUERY__CURRENCIES],
    queryFn: () => getCurrencies(),
  });
};
